var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0474 27.5344V20.791C42.0474 13.091 35.7474 6.79102 28.0474 6.79102C20.324 6.79102 14.0474 13.0677 14.0474 20.791V27.5344C14.0474 28.9577 13.4407 31.1277 12.7174 32.341L10.034 36.7977C8.37736 39.551 9.52069 42.6077 12.554 43.6344C22.6107 46.9944 33.4607 46.9944 43.5174 43.6344C46.3407 42.701 47.5774 39.3644 46.0374 36.7977",
    stroke: "#67E2C2",
    strokeWidth: 4.30769,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3628 7.4693C29.5412 6.66567 26.5512 6.66567 23.7295 7.4693C24.4062 5.74263 26.0862 4.5293 28.0462 4.5293C30.0062 4.5293 31.6862 5.74263 32.3628 7.4693V7.4693Z",
    stroke: "#67E2C2",
    strokeWidth: 4.30769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0469 44.4707C35.0469 48.3207 31.8969 51.4707 28.0469 51.4707C26.1335 51.4707 24.3602 50.6774 23.1002 49.4174C21.7892 48.1044 21.0511 46.3261 21.0469 44.4707",
    stroke: "#67E2C2",
    strokeWidth: 4.30769,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3e7b75b2f61312fa129e26fbced13db9.svg";
export { ForwardRef as ReactComponent };